<template>
    <div class="home-container" :class="{ 'is-mobile' : !isDesktop }" :style="{minHeight: `${minHeight}px`}">
            <Mub v-for="(block,index) in blocks" :block="block" :key="block.key">
                <NormalProducts v-if="block.type == 'NormalProducts'" 
                    :key="block.key" 
                    :block="block"
                    :relative-viewport="relativeViewport"            
                >
                </NormalProducts>
                <ComboProducts v-if="block.type == 'ComboProducts'"
                               :key="block.key"
                               :block="block" 
                               :is-desktop="isDesktop"
                >
                </ComboProducts>
                <VerticalProducts v-if="block.type == 'VerticalProducts'" 
                    :key="block.key" 
                    :block="block" >
                </VerticalProducts>
                <HorizontalProducts v-if="block.type == 'HorizontalProducts'" 
                    :key="block.key" 
                    :block="block" >
                </HorizontalProducts>
                <RankingProducts v-if="block.type == 'RankingProducts'" 
                    :key="block.key" 
                    :block="block" >
                </RankingProducts>
                <Categories v-if="block.type == 'Categories'" 
                    :key="block.key" 
                    :block="block"
                    :relative-viewport="relativeViewport"
                >
                </Categories>
                <BannerSlide v-if="block.type == 'BannerSlide'" 
                    :key="block.key" 
                    :block="block">
                </BannerSlide>
                <PriorityBanner v-if="block.type == 'PriorityBanner'"
                    :key="block.key" 
                    :block="block">
                </PriorityBanner>
            </Mub>
    </div>
</template>
<script>
import Common from '../Common/HomeBlocksCommon.vue';
import BannerSlide from '../Common/Blocks/BannersNew';
import PriorityBanner from '../Common/Blocks/PriorityBanner';
import NormalProducts from '../Common/Blocks/NormalProducts';
import VerticalProducts from '../Common/Blocks/VerticalProducts';
import HorizontalProducts from '../Common/Blocks/HorizontalProducts';
import RankingProducts from '../Common/Blocks/RankingProducts';
import Categories from './Blocks/Categories';
import ComboProducts from '../Desktop/Blocks/ComboProducts';
import Mub from '@/components/Mub';

export default {
    extends: Common,
    components:{
        NormalProducts,
        VerticalProducts,
        HorizontalProducts,
        RankingProducts,
        ComboProducts,
        Categories,
        BannerSlide,
        PriorityBanner,
        Mub,
    }
}
</script>